import { styled, Typography } from "@mui/material";

const ShortenedText = styled(Typography)({
  display: "-webkit-box",
  overflow: "hidden",
  textOverflow: "ellipsis",
  WebkitBoxOrient: "vertical",
});

export default ShortenedText;
